// extracted by mini-css-extract-plugin
module.exports = {"Statistics":"Statistics_Statistics__1Cqn1"};